/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable, Type } from '@angular/core';
import { Widget } from '@app/core/types';
import { WidgetType } from '@shared/types/common';

export type WidgetFactory = () => Widget;

export interface WidgetInfo {
  component: Type<any>;
  factory: WidgetFactory;
  distinctTitle: string;
  enabled: () => boolean;
}

@Injectable({ providedIn: 'root' })
export class DashboardWidgetsRegistry {
  private registry = new Map<WidgetType, WidgetInfo>();

  register(serializedType: WidgetType, widgetInfo: WidgetInfo) {
    this.registry.set(serializedType, widgetInfo);
  }

  get(serializedType: WidgetType) {
    return this.registry.get(serializedType);
  }

  getAll() {
    return [...this.registry.entries()];
  }
}
